import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import NotFound from '../NotFound';
import ListView from './ListView';

const EventPage = ({ match: { path } }) => (
  <Switch>
    <Route exact path={path} component={ListView} />
    <Route component={NotFound} />
  </Switch>
);

EventPage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

export default EventPage;
